import { useState, useCallback } from "react"

const useForceUpdate = () => {
    const [, setTick] = useState(0);
    const update = useCallback(() => {
        setTick(tick => tick + 1);
    }, [])
    return update;
}

export default useForceUpdate;

// const useForceUpdate = () => {
//     const [_update, _setUpdate] = useState(0);
//     const forceUpdate = () => {
//         _setUpdate(_update + 1);
//     }

//     return forceUpdate;
// }
